export class BaseModule {
	debugMode = false;
	_root = document;

	/**
	 * 
	 * @param {string} eventName 
	 * @param {Element} element 
	 * @param {object} data
	 */
	triggerEventOnElement(eventName, element, data = { }) {
		// if (eventName == 'input') {
		// 	console.log('In root', this._root,'the', eventName, 'event on element', element, 'has data', data);
		// }
		// Create the event.
		// console.log('triggering event on element', eventName, element, data);
		if (typeof document !== 'undefined') {
			var event = document.createEvent('Event');
			event.initEvent(eventName, true, true);
			event.data = data;
			element.dispatchEvent(event);
		}
	}
	
	initialize() {
		
	}

	setRoot(root) {
		this._root = root;
	}
	getRoot() {
		this._root;
	}

	setEventListeners() {
	}
}